import { defineComponent } from "vue";
import {
    LogscordVisionConvictions,
    LogscordVisionFaqGroups,
    type LogscordVisionFaqQuestionId,
} from "@logscord/public-site-config";
import { useLocale } from "../../locales/i18n.js";
import {
    PublicFooter,
    PublicNavbar,
} from "./PublicShell.js";


//////////////////////////////////////////////////
//  VISION
//////////////////////////////////////////////////


function questionKey(id: LogscordVisionFaqQuestionId, field: "question" | "lead" | "answer") {
    return `vision.faq.questions.${id}.${field}`;
}

export default defineComponent({
    setup() {
        const { i18n } = useLocale();

        return () => (
            <div class="public-page vision-page">
                <PublicNavbar />

                <main>
                    <section class="public-hero vision-hero" aria-labelledby="vision-title">
                        <span class="landing-kicker">{i18n("vision.hero.kicker")}</span>
                        <h1 id="vision-title">{i18n("vision.hero.title")}</h1>
                        <blockquote>{i18n("vision.hero.quote")}</blockquote>
                        <p>{i18n("vision.hero.description")}</p>
                    </section>

                    <section class="vision-convictions" aria-labelledby="vision-convictions-title">
                        <div class="vision-section-heading">
                            <span class="landing-kicker">{i18n("vision.convictions.kicker")}</span>
                            <h2 id="vision-convictions-title">{i18n("vision.convictions.title")}</h2>
                            <p>{i18n("vision.convictions.description")}</p>
                        </div>

                        <div class="vision-conviction-grid">
                            {LogscordVisionConvictions.map((conviction, index) => (
                                <article
                                    class={{
                                        "vision-conviction-card": true,
                                        "vision-conviction-card-featured": index === 4,
                                    }}
                                    key={conviction.titleKey}
                                >
                                    <i class="material-symbols-outlined" aria-hidden="true">{conviction.icon}</i>
                                    <span class="vision-conviction-index" aria-hidden="true">
                                        {String(index + 1).padStart(2, "0")}
                                    </span>
                                    <h3>{i18n(conviction.titleKey)}</h3>
                                    <p>{i18n(conviction.descriptionKey)}</p>
                                </article>
                            ))}
                        </div>
                    </section>

                    <section class="vision-faq" aria-labelledby="vision-faq-title">
                        <div class="vision-section-heading vision-faq-heading">
                            <span class="landing-kicker">{i18n("vision.faq.kicker")}</span>
                            <h2 id="vision-faq-title">{i18n("vision.faq.title")}</h2>
                            <p>{i18n("vision.faq.description")}</p>
                        </div>

                        <div class="vision-faq-groups">
                            {LogscordVisionFaqGroups.map((group) => (
                                <section class="vision-faq-group" aria-labelledby={`vision-faq-${group.key}`} key={group.key}>
                                    <div class="vision-faq-group-heading">
                                        <span>{i18n(group.kickerKey)}</span>
                                        <h3 id={`vision-faq-${group.key}`}>{i18n(group.titleKey)}</h3>
                                    </div>

                                    <div class="vision-faq-list">
                                        {group.questionIds.map((questionId) => (
                                            <details class="vision-faq-item" name={`vision-faq-${group.key}`} key={questionId}>
                                                <summary>
                                                    <span>{i18n(questionKey(questionId, "question"))}</span>
                                                    <i class="material-symbols-outlined" aria-hidden="true">add</i>
                                                </summary>

                                                <div class="vision-faq-answer">
                                                    <strong>{i18n(questionKey(questionId, "lead"))}</strong>
                                                    <p>{i18n(questionKey(questionId, "answer"))}</p>
                                                </div>
                                            </details>
                                        ))}
                                    </div>
                                </section>
                            ))}
                        </div>
                    </section>
                </main>

                <PublicFooter />
            </div>
        );
    },
});
